import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || 'aql5znog';

export const client = sanityClient({
    projectId,
    dataset:'production',
    apiVersion:'2023-05-12',
    useCdn:true,
});

const  builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
